const traceability = {
	state: {
		archives: {
			list: [],
			page: {
				total: 0
			}
		},
		settle: {
			list: null,
			page: {
				total: 0
			}
		},
		trace: {
			list: [],
			page: {
				total: 0
			},
		}
	},
	mutations: {
		archives(state,value)
		{
			state.archives=value;
		},
		settle(state,value)
		{
			state.settle=value;
		},
		trace(state,value)
		{
			state.trace=value;
		}
	},
	actions: {
		
	},
	getters: {
		detailsT: state=>{
			if(state.trace.list.length==0)
			{
				return null;
			}
			let apiurl="http://admin.farmereasy.com";
			let value=JSON.parse(JSON.stringify(state.trace.list))
			value.avatar=apiurl+value.avatar;
			value.speciesDetailsData.image=apiurl+value.speciesDetailsData.image;
			value.userData.avatar=apiurl+value.userData.avatar;
			let images=[];
			let str=value.images;
			str=str.toString();
			for(let i=0;i<str.split(',').length;i++)
			{
				images.push(apiurl+str.split(',')[i]);
			}
			value.images=images;
			let imagesS=[];
			str=value.speciesDetailsData.images;
			str=str.toString();
			for(let i=0;i<str.split(',').length;i++)
			{
				imagesS.push(apiurl+str.split(',')[i]);
			}
			value.speciesDetailsData.images=imagesS;
			let authimage=[];
			str=value.speciesDetailsData.authimage;
			str=str.toString();
			for(let i=0;i<str.split(',').length;i++)
			{
				authimage.push(apiurl+str.split(',')[i]);
			}
			value.speciesDetailsData.authimage=authimage;
			let growimage=[];
			str=value.speciesDetailsData.growimage;
			str=str.toString();
			for(let i=0;i<str.split(',').length;i++)
			{
				growimage.push(apiurl+str.split(',')[i]);
			}
			value.speciesDetailsData.growimage=growimage;
			for(let i=0;i<value.recordData.length;i++)
			{
				value.recordData[i].image=apiurl+value.recordData[i].image;
				value.recordData[i].operatoravatar=apiurl+value.recordData[i].operatoravatar;
				value.recordData[i].eat.image=apiurl+value.recordData[i].eat.image;
				let imagesR=[];
				str=value.recordData[i].images;
				str=str.toString();
				for(let i=0;i<str.split(',').length;i++)
				{
					imagesR.push(apiurl+str.split(',')[i]);
				}
				value.recordData[i].images=imagesR;
				let imagesE=[];
				str=value.recordData[i].eat.images;
				str=str.toString();
				for(let i=0;i<str.split(',').length;i++)
				{
					imagesE.push(apiurl+str.split(',')[i]);
				}
				value.recordData[i].eat.images=imagesE;
			}
			return value;
		}
	}
};
export default {
	namespaced: true,
	traceability
};
